<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div *ngIf="isAuthenticated$ | async as auth" class="page">
  <ng-container *ngIf="auth?.isAuthenticated; else notAuth">
    <div *ngIf="userData$ | async as userData" class="content flex flex-col gap-4">

      <!-- ── Card 1: Mein Profil ── -->
      <p-card>
        <ng-template pTemplate="header">
          <div class="flex items-center justify-between gap-3 px-6 pt-5 pb-4 border-b border-surface-200">
            <div class="flex items-center gap-3">
              <div class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-100 text-primary-600">
                <i class="pi pi-user text-lg"></i>
              </div>
              <div>
                <h2 class="text-lg font-semibold leading-tight">Mein Profil</h2>
                <p class="text-sm text-gray-500 leading-tight">{{ (userData$ | async)?.userData?.email }}</p>
              </div>
            </div>
            <div class="flex items-center gap-3">
              <p class="text-sm text-gray-500">Passwort, 2FA und Sicherheitseinstellungen verwalten</p>
              <p-button
                type="button"
                label="Authentifizierungs Profil"
                icon="pi pi-external-link"
                severity="secondary"  
                [outlined]="true"
                (click)="openAuthUserProfile()"
              ></p-button>
            </div>
          </div>
        </ng-template>

        <div class="flex flex-col gap-4 pt-2">
          <h3 class="text-sm font-semibold uppercase tracking-wide text-gray-400">
            Zugewiesene necta Benutzer
          </h3>
          <p-table [value]="(userProfile()?.nectaUsers ?? [])">
            <ng-template pTemplate="header">
              <tr>
                <th>Mandanten-Id</th>
                <th>Mandanten Bezeichnung</th>
                <th>necta Benutzername</th>
                <th>Rolle</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
              <tr>
                <td>{{ user.tenantId }}</td>
                <td>{{ user.tenantDescription }}</td>
                <td>{{ user.nectaUserCode }}</td>
                <td>{{ getUserRole(user.userGroupType) }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4" class="text-center text-gray-400 py-4">Keine Benutzer zugewiesen.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-card>

     <!-- ── Card 2: API-Keys ── -->
       @if(userStore.isRegisteredNectaOne() === true) {
      <p-card header="API-Keys">
        <div class="mb-4 flex justify-between items-center gap-4">
          <p class="text-sm text-gray-500">
            API-Keys ermöglichen den Zugriff auf die necta.one API ohne Benutzeranmeldung.
            Bewahren Sie Ihren Schlüssel sicher auf – er wird nur einmal vollständig angezeigt.
          </p>
          <div class="shrink-0">
            <p-button
            [rounded]="true"
              label="Neuen API-Key erstellen"
              icon="pi pi-plus"
              styleClass="function-btn" 
              (click)="showCreateDialog = true"
            ></p-button>
          </div>
        </div>
     

        <!-- Dialog: API-Key erstellen -->
        <p-dialog
          header="Neuen API-Key erstellen"
          [(visible)]="showCreateDialog"
          [modal]="true"
          [style]="{ width: '400px' }"
          (onHide)="newKeyLabel = ''; newKeyLabelInvalid = false"
        >
          <div class="flex flex-col gap-3">
            <label for="newKeyLabelInput" class="ds-field-label">Label <span class="text-red-500">*</span></label>
            <input
              id="newKeyLabelInput"
              pInputText
              [(ngModel)]="newKeyLabel"
              (ngModelChange)="newKeyLabelInvalid = false"
              placeholder="z.B. CI/CD Pipeline"
              class="w-full"
              [class.ng-invalid]="newKeyLabelInvalid"
              [class.ng-dirty]="newKeyLabelInvalid"
            />
            <small *ngIf="newKeyLabelInvalid" class="text-red-500">Label ist ein Pflichtfeld.</small>
          </div>
          <ng-template pTemplate="footer">
            <p-button
              label="Abbrechen"
              severity="secondary"
              [text]="true"
              (click)="showCreateDialog = false; newKeyLabel = ''"
            ></p-button>
            <p-button
              label="Erstellen"
              icon="pi pi-plus"
              styleClass="function-btn"
              (click)="createApiKey()"
            ></p-button>
          </ng-template>
        </p-dialog>

        <!-- Neu erstellter Key Banner -->
        <div
          *ngIf="apiKeyStore.newlyCreatedKey() as newKey"
          class="mb-4 p-3 border border-green-400 bg-green-50 rounded-lg flex items-center justify-between gap-2"
        >
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <span class="text-sm font-semibold text-green-800">
              ✅ Ihr neuer API-Key (nur einmal sichtbar):
            </span>
            <code class="text-s break-all text-green-900">{{ newKey }}</code>
          </div>
          <div class="flex gap-2 shrink-0">
            <p-button
              icon="pi pi-copy"
              label="Kopieren"
              size="small"
              (click)="copyToClipboard(newKey)"
            ></p-button>
            <p-button
              icon="pi pi-times"
              severity="secondary"
              size="small"
              (click)="dismissNewKey()"
            ></p-button>
          </div>
        </div>

         <p-table [value]="filteredApiKeys" [loading]="apiKeyStore.isLoading()">
          <ng-template pTemplate="header">
            <tr>
              <th>Schlüssel</th>
              <th>Bezeichnung</th>  
              <th>Erstellt am</th>
              <th>Status</th>
              <th>Widerrufen am</th>
              <th>Aktionen</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-key>
            <tr>
              <td>
                  <code class="text-s tracking-wider">
                    <span>ak_•••••{{ key.keySuffix }}</span>
                  </code>
              </td>
              <td>{{ key.label || '—' }}</td>
              <td>{{ key.creationDate | date: 'dd.MM.yyyy HH:mm' }}</td>
              <td>
                <p-tag
                  [value]="key.revokedAt ? 'Widerrufen' : 'Aktiv'"
                  [severity]="key.revokedAt ? 'danger' : 'success'"
                ></p-tag>
              </td>
              <td>{{ key.revokedAt ? (key.revokedAt | date: 'dd.MM.yyyy HH:mm') : '—' }}</td>
              <td>
                <div class="flex gap-2" *ngIf="!key.revokedAt">
                  <p-button
                    icon="pi pi-refresh"
                    label="Erneuern"
                    severity="warn"
                    size="small"
                    [text]="true"
                    (click)="confirmRotate(key.keyHash)"    
                  ></p-button>
                  <p-button
                    icon="pi pi-ban"
                    label="Widerrufen"
                    severity="danger"
                    size="small"
                    [text]="true"
                    (click)="confirmRevoke(key.keyHash)"
                  ></p-button>
                </div>
                <span *ngIf="key.revokedAt" class="text-gray-400 text-sm">—</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-gray-400 py-4">Keine API-Keys vorhanden.</td>
            </tr>
          </ng-template>
        </p-table>

        <div class="mt-3 flex items-center gap-2">
          <p-checkbox [(ngModel)]="showOldRevoked" [binary]="true" inputId="showOldRevoked"></p-checkbox>
          <label for="showOldRevoked" class="text-sm text-gray-500 cursor-pointer">
            Widerrufene Schlüssel älter als 1 Monat anzeigen
          </label>
        </div>
      </p-card>
 }
    </div>
  </ng-container>
  <ng-template #notAuth>
    <p>User is not authenticated.</p>
  </ng-template>
</div>